export const typesValidation = {
  onlyNumber: 'onlyNumber',
  onlyLetters: 'onlyLetters',
  onlyLettersExtend: 'onlyLettersExtend',
  onlyAlphanumeric: 'onlyLaphanumeric',
  onlyAlphanumericExtend: 'onlyLaphanumericExtend',
  onlyPassword: 'onlyPassword',
  validateEmail: 'validateEmail',
  validateEmailDomain: 'validateEmailDomain',
  lettersExtend: 'lettersExtend',
};
